module.exports = __webpack_public_path__ + "static/media/hero-nike.2e327a11.jpg";